<div class="card" id="performanta" [formGroup]="animalForm">
  <div class="card-header">Performanță</div>

  <div class="card-body">
    <div class="row  d-flex column-gap-4">
      <div class="col-auto mb-3">
        <div>
          <label>
            Greutate la naștere
          </label>
          <div class="d-flex align-items-center">
            <input
              type="number"
              min="0"
              placeholder="GN"
              class="form-control w7"
              formControlName="greutate_nastere"
              [readonly]="disabledFields['greutate_nastere']"
            />
            <span class="fs-5 font-weight-bold pl-1">kg</span>
          </div>
        </div>
      </div>

      <div class="col-auto d-flex column-gap-3 mb-3">
        <div>
          <label>
            Greutate la 120 zile
          </label>
          <div class="d-flex align-items-center">
            <input
              type="number"
              min="0"
              placeholder="G120"
              class="form-control w7"
              formControlName="gvr120"
              [readonly]="disabledFields['gvr120']"
              />
            <span class="fs-5 font-weight-bold pl-1">kg</span>
          </div>
        </div>

        <div>
          <label>
            SMZ la 120 zile
          </label>

          <div class="d-flex align-items-center">
            <input
              type="number"
              min="0"
              id="smz120"
              placeholder="SMZ120"
              class="form-control w7"
              formControlName="smz120"
              [readonly]="disabledFields['smz120']"
            />
            <span class="fs-5 font-weight-bold pl-1">g</span>
          </div>
        </div>
      </div>

      <div class="col-auto d-flex column-gap-3 mb-3">
        <div class="d-flex align-items-center flex-column">
          <label>
            Greutate la 200 zile
          </label>

          <div class="d-flex align-items-center">
            <input
              type="number"
              min="0"
              placeholder="G200"
              class="form-control w7"
              formControlName="gvr200"
              [readonly]="disabledFields['gvr200']"
            />
            <span class="fs-5 font-weight-bold pl-1">kg</span>
          </div>
        </div>

        <div class="">
          <label>
            SMZ la 200 zile
          </label>

          <div class="d-flex align-items-center">
            <input
              type="number"
              min="0"
              id="smz200"
              placeholder="SMZ200"
              class="form-control w7"
              formControlName="smz200"
              [readonly]="disabledFields['smz200']"
            />
            <span class="fs-5 font-weight-bold pl-1">g</span>
          </div>
        </div>
      </div>

      <div class="col-auto d-flex column-gap-3 mb-3">
        <div class="d-flex align-items-center flex-column">
          <label>
            Greutate la 365 zile
          </label>

          <div class="d-flex align-items-center">
            <input
              type="number"
              min="0"
              placeholder="G365"
              class="form-control w7"
              formControlName="gvr365"
              [readonly]="disabledFields['gvr365']"
              />
            <span class="fs-5 font-weight-bold pl-1">kg</span>
          </div>
        </div>

        <div class="">
          <label>
            SMZ la 365 zile
          </label>

          <div class="d-flex align-items-center">
            <input
              type="number"
              min="0"
              id="smz365"
              placeholder="SMZ365"
              class="form-control w7"
              formControlName="smz365"
              [readonly]="disabledFields['smz365']"
            />
            <span class="fs-5 font-weight-bold pl-1">g</span>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-auto">
        <div class="mb-3">
          <label>
            DM
          </label>
          <div class="input-group">
            <div class="input-group-prepend">
              <input
                id="dm"
                placeholder="DM"
                formControlName="dm"
                type="number"
                min="0"
                class="form-control w6"
                [ngClass]="{ disabled: disabledFields['dm'] }"
              />
              <button
                class="btn btn-sm btn-icon btn-blue"
                title="Editează"
                type="button"
                (click)="openModalBonitare('dm')"
                [ngClass]="{ disabled: disabledFields['dm'] }"
              >
                <i class="mdi mdi-square-edit-outline"></i>
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="col-auto">
        <div class="mb-3">
          <label>
            DS
          </label>
          <div class="input-group">
            <div class="input-group-prepend">
              <input
                type="number"
                min="0"
                id="ds"
                placeholder="DS"
                class="form-control w6"
                [ngClass]="{ disabled: disabledFields['ds'] }"
                formControlName="ds"
              />
              <button
                class="btn btn-sm btn-icon btn-blue"
                title="Editează"
                type="button"
                (click)="openModalBonitare('ds')"
                [ngClass]="{ disabled: disabledFields['ds'] }"
              >
                <i class="mdi mdi-square-edit-outline"></i>
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="col-auto">
        <div class="mb-3">
          <label>
            AF
          </label>
          <div class="input-group">
            <div class="input-group-prepend">
              <input
                type="number"
                min="0"
                id="af"
                placeholder="AF"
                class="form-control w6"
                [ngClass]="{ disabled: disabledFields['af'] }"
                formControlName="af"
              />
              <button
                class="btn btn-sm btn-icon btn-blue"
                title="Editează"
                type="button"
                (click)="openModalBonitare('af')"
                [ngClass]="{ disabled: disabledFields['af'] }"
              >
                <i class="mdi mdi-square-edit-outline"></i>
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="col-auto">
        <div class="mb-3">
          <label>
            CR
          </label>
          <input
            type="number"
            min="0"
            id="cr"
            placeholder="CR"
            class="form-control w6"
            formControlName="cr"
            [ngClass]="{ disabled: disabledFields['cr'] }"
          />
        </div>
      </div>

      <div class="col-auto">
        <div class="mb-3">
          <label>
            IFNAIS
          </label>
          <input
            type="number"
            min="0"
            id="ifnais"
            placeholder="IFNAIS"
            class="form-control w6"
            formControlName="ifnais"
            [ngClass]="{ disabled: disabledFields['ifnais'] }"
          />
        </div>
      </div>

      <div class="col-auto">
        <div class="mb-3">
          <label>
            CRSEVR
          </label>
          <input
            type="number"
            min="0"
            id="crsevr"
            placeholder="CRSEVR"
            class="form-control w6"
            formControlName="crsevr"
            [ngClass]="{ disabled: disabledFields['crsevr'] }"
          />
        </div>
      </div>

      <div class="col-auto">
        <div class="mb-3">
          <label>
            DMSEV
          </label>
          <input
            type="number"
            min="0"
            id="dmsev"
            placeholder="DMSEV"
            class="form-control w6"
            formControlName="dmsev"
            [ngClass]="{ disabled: disabledFields['dmsev'] }"
          />
        </div>
      </div>

      <div class="col-auto">
        <div class="mb-3">
          <label>
            DSSEV
          </label>
          <input
            type="number"
            min="0"
            id="dssev"
            placeholder="DSSEV"
            class="form-control w6"
            formControlName="dssev"
            [ngClass]="{ disabled: disabledFields['dssev'] }"
          />
        </div>
      </div>

      <div class="col-auto">
        <div class="mb-3">
          <label>
            ISEVR
          </label>
          <input
            type="number"
            min="0"
            id="isevr"
            placeholder="ISEVR"
            class="form-control w6"
            formControlName="isevr"
            [ngClass]="{ disabled: disabledFields['isevr'] }"
          />
        </div>
      </div>

      <div class="col-auto">
        <div class="mb-3">
          <label>
            AVEL
          </label>
          <input
            type="number"
            min="0"
            id="avel"
            placeholder="AVEL"
            class="form-control w6"
            formControlName="avel"
            [ngClass]="{ disabled: disabledFields['avel'] }"
          />
        </div>
      </div>

      <div class="col-auto">
        <div class="mb-3">
          <label>
            ALAIT
          </label>
          <input
            type="number"
            min="0"
            id="alait"
            placeholder="ALAIT"
            class="form-control w6"
            formControlName="alait"
            [ngClass]="{ disabled: disabledFields['alait'] }"
          />
        </div>
      </div>

      <div class="col-auto">
        <div class="mb-3">
          <label>
            IVMAT
          </label>
          <input
            type="number"
            min="0"
            id="ivmat"
            placeholder="IVMAT"
            class="form-control w6"
            formControlName="ivmat"
            [ngClass]="{ disabled: disabledFields['ivmat'] }"
          />
        </div>
      </div>
    </div>

    <div class="row mb-2">
      <div class="col-auto mb-1">
        <h5 *ngIf="evaluareGenetica">
          Evaluare Genetică
        </h5>
        <h5 *ngIf="! evaluareGenetica">
          Nu are Evaluare Genetică
        </h5>
      </div>

      <div
        *ngIf="evaluareGenetica"
        class="col-12 d-flex flex-wrap column-gap-1 zoom-sm-75"
      >
        <div
          *ngFor="let key of ev_gen_cols"
          class="border text-center mb-2"
          [ngClass]="{
            'max-w4': key !== 'data',
            'w-auto': key === 'data',
          }"
        >
          <div
            class="height5 bg-light border-bottom d-flex align-items-center justify-content-center"
            [ngbTooltip]="columnsDesc[key]['desc']"
          >
            {{ columnsDesc[key]['abr'] }}
          </div>

          <div
            class="text-center"
            [ngClass]="{
              'number': number.indexOf(key) != -1,
              'percent': percent.indexOf(key) != -1
            }"
          >{{ evaluareGenetica[key] }}</div>
        </div>
      </div>
    </div>

    <div class="row column-gap-4">
      <div class="col-auto d-flex flex-wrap align-items-center column-gap-1">
        <h5 *ngIf="form.filename_fisabonitare.value">
          Fișă bonitare
        </h5>
        <h5 *ngIf="! form.filename_fisabonitare.value">
          Nu are Fișă bonitare
        </h5>

        <app-upload-fisier
          *ngIf="!form.filename_fisabonitare.value && !disabledFields['filename_fisabonitare']"
          (ApiResponse)="uploadServerResponseFisaBonitare($event)"
        >
        </app-upload-fisier>

        <div>
          <span
            *ngIf="form.filename_fisabonitare.value"
            class="file-button"
            (click)="downloadFisaBonitare()"
          >
            {{ form.filename_fisabonitare.value }}
          </span>

          <button
            *ngIf="form.filename_fisabonitare.value && !disabledFields['filename_fisabonitare']"
            type="button"
            class="btn btn-lg p-0 ml-1 mdi mdi-delete text-danger"
            ngbTooltip="Șterge fișier"
            (click)="deleteFisaBonitare()"
          >
          </button>
        </div>
      </div>

      <div class="col-auto d-flex flex-wrap align-items-center column-gap-3">
        <h5 *ngIf="form.file_name_apr_feno.value">
          Buletin apreciere fenotipică
        </h5>
        <h5 *ngIf="! form.file_name_apr_feno.value">
          Nu are Buletin apreciere fenotipică
        </h5>

        <app-upload-fisier
          *ngIf="!form.file_name_apr_feno.value && !disabledFields['file_name_apr_feno']"
          (ApiResponse)="uploadServerResponseApreciereFenotipica($event)"
        >
        </app-upload-fisier>

        <div *ngIf="form.file_name_apr_feno.value">
          <label>Nr.</label>

          <input
            type="text"
            class="form-control d-inline w5"
            placeholder="Introduceți numărul documentului"
            formControlName="docnr_apr_feno"
            [ngClass]="{
              'is-invalid': submitted && form.docnr_apr_feno.errors
            }"
            [readonly]="disabledFields['docnr_apr_feno']"
          />
          <div
            *ngIf="submitted && form.docnr_apr_feno.errors"
            class="invalid-feedback"
          >
            <div *ngIf="form.docnr_apr_feno.errors.required">
              Completarea acestui câmp este obligatorie.
            </div>
          </div>
        </div>

        <div *ngIf="form.file_name_apr_feno.value">
          <label>Data</label>

          <app-date-picker
            class="d-inline-block"
            [submitted]="submitted"
            [required]="form.file_id_apr_feno.value ? true : false"
            [selectedDate]="form.data_apr_feno.value"
            [disabled]="disabledFields['data_apr_feno']"
            (dateChanged)="documentDataChanged($event)"
          >
          </app-date-picker>
        </div>

        <div>
          <span
            *ngIf="form.file_name_apr_feno.value"
            class="file-button"
            (click)="downloadApreciereFenotipica()"
          >
            {{ form.file_name_apr_feno.value }}
          </span>

          <button
            *ngIf="form.file_name_apr_feno.value && !disabledFields['file_name_apr_feno']"
            type="button"
            class="btn btn-lg p-0 ml-1 mdi mdi-delete text-danger"
            ngbTooltip="Șterge fișier"
            (click)="deleteApreciereFenotipica()"
          >
          </button>
        </div>
      </div>
    </div>

  </div>
</div>

<app-add-update-fisa-bonitare
  [openBonitare]="openBonitare"
  [bonitareType]="bonitareType"
  (notifyBonClose)="closeBonitareModal($event)"
  (dmValue)="dmValue($event)"
  (dsValue)="dsValue($event)"
  (afValue)="afValue($event)"
></app-add-update-fisa-bonitare>
